import './app/config/logging'; // Must be first import for proper instrumentation
import App from './app/App.tsx';
import './app/styles/index.css';
import './app/styles/tailwind.css';
import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import store from './app/store/store.ts';
import { createRoot } from 'react-dom/client';
import { TgProvider } from './app/providers/TgProvider.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <TgProvider>
        <App />
      </TgProvider>
    </Provider>
  </StrictMode>,
);
